(() => {
	angular.module('main').directive('updateJobModal', updateJobModal);

	updateJobModal.$inject = [
		'$rootScope',
		'$route',
		'$location',
		'$timeout',
		'newJobsDataService',
		'clientsDataService',
		'clientService',
		'jobService',
		'messageService',
		'timeService',
		'validationService',
		'timeConverter',
		'stringModifierService',
		'settingsService',
		'utilsService',
		'leadSourcesDataService'
	];

	function updateJobModal(
		$rootScope,
		$route,
		$location,
		$timeout,
		newJobsDataService,
		clientsDataService,
		clientService,
		jobService,
		messageService,
		timeService,
		validationService,
		timeConverter,
		stringModifierService,
		settingsService,
		utilsService,
		leadSourcesDataService
	) {
		return {
			restrict: 'E',
			scope: {
				updateParent: '&?',
				mainShootLabelName: '=',
				extraShootLabelName: '=',
				businessNumberLabelName: '='
			},
			template: `<section id="main-wrapper" class="container">
                         <div id="newJob" class="modal modal-center fade" data-backdrop="static" data-keyboard="false" data-autotest-modal="newEditJob">
                                <div class="modal-dialog modal-dialog-datepicker">  
                                    <div class="modal-content">
                                        <form class="form form-horizontal" role="form" ng-submit="addOrUpdateJob()">
                                            <div class="modal-header pt-pb-15">
                                                <btn-close ng-click="clearJobInfo()"></btn-close>
                                                <h3 class="modal-title">{{ job.id || job.id === 0 ? 'Edit Job' : 'New Job' }}</h3>
                                            </div>
                                            <div class="modal-body" style="padding: 30px!important">
                        
                                                <h3 class="mt-0 mb-30">Primary client contact</h3>
                        
                                                <div class="clearfix grey-group-item mb-0 ps-0 text-xs-center text-sm-left">
                                                    <div class="col-xs-12 col-sm-2 text-nowrap">
                                                        <h4>Choose client</h4>
                                                    </div>
                                                    <div class="col-xs-12 col-sm-6">
                                                        <input placeholder="Start entering client name" class="form-control" type="text" autocomplete="off"
                                                               typeahead="idName as idName.name  for idName in idsNames | filter:$viewValue"
                                                               ng-model="job.primaryContact">
                                                    </div>
                                                    <div class="col-xs-12 col-sm-1 row visible-xs-block">
                                                        <h4>OR</h4>
                                                    </div>
                                                    <div class="col-xs-12 col-sm-4 flex-row">
                                                        <h4 class="hidden-xs flex-grow-1 ml-n7">OR</h4>
                                                        <button type="button" ng-disabled="button_disable"
                                                                ng-click="createNewClient(0, $event)"
                                                                class="btn btn-info btn-add-new-sm mb-0 fs-14" data-autotest-button="addNewClientFirst">Add new client
                                                        </button>
                                                    </div>
                                                </div>
                        
                                                <div class="clearfix grey-group-item m-30 ps-0 second-client" ng-show="showSecondClient">
                                                    <div class="col-xs-12 col-sm-2 text-nowrap">
                                                        <h4>Choose client</h4>
                                                    </div>
                                                    <div class="col-xs-12 col-sm-6">
                                                        <input placeholder="Start entering client name" class="form-control" type="text"
                                                               typeahead="idName as idName.name for idName in idsNames | filter:$viewValue"
                                                               ng-model="job.secondaryContact">
                                                    </div>
                                                    <div class="col-xs-12 col-sm-1 row visible-xs-block">
                                                        <h4>OR</h4>
                                                    </div>
                                                    <div class="col-xs-12 col-sm-4 flex-row">
                                                        <h4 class="hidden-xs flex-grow-1 ml-n7">OR</h4>
                                                        <button type="button" ng-disabled="button_disable"
                                                                ng-click="createNewClient(1, $event)"
                                                                class="btn btn-info btn-add-new-sm mb-0 fs-14" data-autotest-button="addNewClientSecond">Add new client
                                                        </button>
                                                    </div>
                                                    <button type="button" class="close" ng-disabled="button_disable"
                                                            ng-click="remove()" data-autotest-button="close">&times;</button>
                                                </div>
                        
                                                <button type="button" ng-if="!showSecondClient" ng-disabled="button_disable" ng-click="add()"
                                                        class="btn btn-info btn-add-new-sm mt-20" data-autotest-button="addSecondaryClient">
                                                    <span class="hidden-xs fs-14">Add secondary client contact</span>
                                                    <span class="visible-xs fs-14">Add secondary</span>
                                                </button>
                        
                                                <hr>
                                                <h3 class="mt-30 mb-25">Job details</h3>
                                                <div class="row">
                                                    <div class="col-sm-2">
                                                        <label class="control-label">Job name:</label>
                                                    </div>
                                                    <div class="col-sm-8 mb-15">
                                                        <input type="text" id="job-name" autocomplete="off" class="form-control" maxlength="255" placeholder="Jenny & Matt"
                                                               ng-model="job.name" required>
                                                    </div>
                                                </div>
                                              
                                                <div class="row">
                                             
                                                    <div class="col-sm-2">
                                                        <label class="control-label">Job type:</label>
                                                    </div>
                                                    <div class="col-sm-8 mb-15">
                                                        <div class="select-style">
                                                             <select id="job-type" 
                                                                    ng-model="job.type"
                                                                    ng-change="typeChanged(job.type)"
                                                                    ng-options="jobType.name for jobType in job.jobTypes | orderBy:'name' track by jobType.name"
                                                             ></select>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                 <div class="row">
                                                    <div class="col-sm-2">
                                                        <label class="control-label">Workflow:</label>
                                                    </div>
                                                    <div class="col-sm-8 mb-15">
                                                        <div class="select-style">
                                                            <select ng-options="workflow.name for workflow in job.workflowNames | orderBy:'name' track by workflow.name"
                                                                    ng-model="job.workflow" 
                                                                    ng-disabled="disableWorkflow">
                                                                    <option value="" ng-show="disableWorkflow">Default</option>
                                                            </select>
                           
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-8 col-sm-offset-2 select-style-error" ng-show="disableWorkflow">
                                                        Custom workflow cannot be applied to past jobs.
                                                    </div>
                                                </div>
                                                
                                                <div class="row" ng-if="leadSourcesAvailable">
                                                    <div class="col-sm-2 pr-0">
                                                        <label class="control-label">Lead Source:</label>
                                                    </div>
                                                    <div class="col-sm-8 mb-15">
                                                        <div class="select-style">
                                                            <select id="lead-type" 
                                                                    ng-model="job.leadSource"
                                                                    ng-options="leadSource.name for leadSource in leadSources | orderBy:'name' track by leadSource.name"
                                                             ><option value="">None</option></select>
                                                        </div>
                                                    </div>
                                                </div>
                                         
                                                <hr>
                                                <h3 class="mt-30 mb-25">{{mainShootLabelName}}</h3>
                                                
                                                <div class="flex-row mb-25">
                                                    <div class="checkbox-squared">
                                                        <input type="checkbox" id="noDateJob" ng-model="job.hasNoDate"/>
                                                        <label for="noDateJob"></label>
                                                    </div>
                                    
                                                    <label for="noDateJob">
                                                       No date has been confirmed yet
                                                    </label>
                                                </div>
                                                
                                                <section ng-if="!job.hasNoDate">
                                               
                                                    <div class="row">
                                                     
                                                        <div class="col-sm-2">
                                                            <label class="control-label">Date:</label>
                                                        </div>
                                                        
                                                        <div class="col-sm-8 job-date">
                                                            <div class="flex-row flex-wrap-xs">
                                                                <div class="flex-grow-1 mb-15 box-no-transition datepicker-static under-input">
                                                                   
                                                                    <input ng-model="job.startDate" class="form-control"
                                                                           ng-change="job.finishDate = job.startDate"
                                                                           type="date" name="input"
                                                                           data-placeholder="{{datapickerDateFormat}}" 
                                                                           min="2001-12-31"
                                                                           max="2999-12-31"
                                                                           data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                                </div>
                                                                
                                                                <div class="flex-basis-xs ms-15 mb-15 fs-16">to</div>
                                                                
                                                                <div class="flex-grow-1 mb-15 box-no-transition datepicker-static under-input">
                                                                    <input ng-model="job.finishDate" class="form-control"
                                                                           type="date" name="input" 
                                                                           data-placeholder="{{datapickerDateFormat}}" 
                                                                           min="{{( job.startDate ) ? ( job.startDate | date : 'yyyy-MM-dd') : (now | date : 'yyyy-MM-dd') }}"
                                                                           max="2999-12-31"
                                                                           data-date='{"startView": 2, "openOnMouseFocus": true}' required/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="col-sm-2 mb-15 pt-6 flex-row">
                                                            <div class="checkbox-squared">
                                                                <input type="checkbox" id="checkbox-squared-all-job-day-event" ng-model="job.allday"/>
                                                                <label for="checkbox-squared-all-job-day-event"></label>
                                                            </div>
                                                            <label for="checkbox-squared-all-job-day-event">All day</label>
                                                        </div>
                                                    </div>
                                                    
                                                
                                                    <div class="row">
                                                        <div class="col-sm-2">
                                                            <label class="control-label">Time:</label>
                                                        </div>
                                                        <div class="col-sm-8 job-date">
                                                             <div class="flex-row flex-wrap-xs">
                                                                <div class="flex-grow-1 mb-15">
                                                                    <sn-timepicker dom-time="job_start_time" sn-dr-model="job.startTime" sn-dr-checked="job.allday"></sn-timepicker>
                                                                </div>
                                                                <div class="flex-basis-xs ms-15 mb-15 fs-16">to</div>
                                                                <div class="flex-grow-1 mb-15">
                                                                    <sn-timepicker dom-time="job_finish_time" sn-dr-model="job.finishTime" sn-dr-checked="job.allday"></sn-timepicker>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                             
                                               </section>
                                               
                                                
                                                <div class="flex-row flex-wrap-xs warning-message m-0 mb-25" ng-if="job.hasNoDate"> 
                                                	<warning-sign-img></warning-sign-img>
                                                    <div class="warning-message__text">
                                                        <p>This job has no date:</p>
                                                        <ul>
                                                            <li>The {{ mainShootLabelName | lowercase }} will not appear in your Calendar.</li>
                                                            <li>Automated workflow tasks dependent on {{ mainShootLabelName | lowercase }} date will not trigger.</li>
                                                            <li>The %job_date% variable will display "No date".</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                
                                                <div class="row">
                                                    <div class="col-sm-2">
                                                        <label class="control-label">Location:</label>
                                                    </div>
                                                    <input type="text" class="hide hidden form-control" name="job.location"
                                                           ng-model="job.location"/>
                                                    <div class="col-sm-8 mb-15 box-no-transition" ng-controller="GoogleAutocompleteController">
                                                        <input type="text" id="AutocompleteJobModal" ng-model="autocomplete" placeholder=""
                                                               class="form-control" ng-autocomplete options="options" details="details"/>
                                                    </div>
                                                </div>
                        
                                                <hr>
                                                <h3 class="mt-30 mb-25">Job Notes:</h3>
                                                <sn-text-angular sn-model="job.notes" sn-name="job_notes"></sn-text-angular>
                        
                                            </div>
                                            <div class="modal-footer modal-foot">
                                                <button type="submit" ng-disabled="button_disable" 
                                                        class="btn btn-success btn-lg"
                                                        spinning-wheel is-spinning-wheel-active="button_disable"
                                                >Save Job</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <create-new-client-modal id="createNewJobClientModal" 
                                                     company-name-checked="companyNameChecked" 
                                                     client="newClient" 
                                                     save-client="saveClient(event)"
                                                     on-close="closeAddClient(event)"
                                                     is-create-client-modal-spinnning-wheel-active="isCreateClientModalSpinnningWheelActive"
                                                     business-number-label-name="businessNumberLabelName"
                            ></create-new-client-modal>
                         </section>
                    
`,
			replace: true,
			transclude: true,
			link(scope) {
				let clientsSearchTimer;

				scope.$on('showModalJob', (event, job) => {
					scope.job = angular.copy(job);
					scope.leadSources = [];
					if (scope.job.leadSource) {
						const { leadSource } = scope.job;
						if (leadSource.status === 'ARCHIVED') {
							leadSource.name += ' (archived)';
						}
						scope.leadSources.push(leadSource);
					}
					scope.now = new Date();
					scope.now.setHours(0, 0, 0, 0);
					scope.idsNames = [];
					scope.newClient = {};

					settingsService.timeFormatSettings.subscribe(data => {
						scope.dataFormatMonth = data.dateFormat;
						scope.leadSourcesAvailable = data.leadSourcesAvailable;
					});

					leadSourcesDataService.getActiveLeadSourcesList().subscribe(data => {
						const { leadSource } = scope.job;
						leadSource && leadSource.status === 'ARCHIVED'
							? (scope.leadSources = [...scope.leadSources, ...data.data])
							: (scope.leadSources = [...data.data]);
					});

					scope.datapickerDateFormat =
						scope.dataFormatMonth === 'DD_MM_YYYY'
							? 'dd/mm/yyyy'
							: 'mm/dd/yyyy';

					if (
						scope.job.secondaryContact === null ||
						scope.job.secondaryContact === undefined
					) {
						scope.showSecondClient = false;
					} else {
						scope.showSecondClient = true;
					}

					if (!job.id) {
						const defaultType = scope.job.jobTypes.find(
							type => type.default === true
						);
						scope.job.type = defaultType;
						scope.job.workflow = defaultType.workflow;
					}
					if (job.id && job.startTime) {
						scope.job.startTime = timeConverter.convert24to12(
							scope.job.startTime
						);
						scope.job.finishTime = timeConverter.convert24to12(
							scope.job.finishTime
						);
					}

					checkJobDate(scope.job.startDate);
					$('#newJob')
						.find('input.ws-date')
						.prop('autocomplete', 'off');
				});

				scope.$watch('job.startDate', checkJobDate);

				scope.$watch('job.startTime', (newValue, oldValue) => {
					if (scope.job && newValue && newValue !== oldValue) {
						const startTime24 = timeConverter.convert12to24(newValue);
						const startHour = timeService.getHour(startTime24);
						const startMin = timeService.getMinutes(startTime24);

						const finishTime24 = timeConverter.convert12to24(
							scope.job.finishTime
						);
						const finishHour1 = timeService.getHour(finishTime24);
						if (!scope.job.id || !scope.job.finishTime) {
							let finishHour = startHour + 1;

							if (finishHour > 23) {
								finishHour = 0;
							}

							const finishTime = `${finishHour}:${startMin}`;

							scope.job.finishTime = timeConverter.convert24to12(finishTime);
						}
						if (startHour === finishHour1 - 1 || startHour === finishHour1) {
							let finishHour = startHour + 1;

							if (finishHour > 23) {
								finishHour = 0;
							}

							const finishTime = `${finishHour}:${startMin}`;

							scope.job.finishTime = timeConverter.convert24to12(finishTime);
						}
					}
				});

				scope.$watch('job.secondaryContact', (newValue, oldValue) => {
					if (newValue === null || oldValue === newValue) {
						return false;
					}

					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}

						clientsSearchTimer = setTimeout(
							findAllMatchingClientNames(newValue),
							500
						);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				scope.$watch('job.primaryContact', (newValue, oldValue) => {
					if (newValue == null) {
						return;
					}
					if (oldValue === newValue) {
						return;
					}
					if (newValue.length > 0) {
						if (clientsSearchTimer != null) {
							clearTimeout(clientsSearchTimer);
						}

						clientsSearchTimer = setTimeout(
							findAllMatchingClientNames(newValue),
							500
						);
					} else {
						clearTimeout(clientsSearchTimer);
					}
				});

				scope.typeChanged = type => {
					if (scope.job.id) {
						return;
					}

					if (!scope.disableWorkflow) {
						scope.job.workflow = type.workflow;
					}
				};

				function setFinishDate(jobStartDate) {
					if (!scope.job.finishDate || jobStartDate > scope.job.finishDate) {
						scope.job.finishDate = jobStartDate;
					}
				}

				function getDefaultWorkflow(workflows) {
					return workflows.find(workflow => workflow.name === 'Default');
				}

				function checkJobDate(jobStartDate) {
					if (scope.job && jobStartDate) {
						if (!scope.job.id) {
							setFinishDate(jobStartDate);
							scope.disableWorkflow = new Date(jobStartDate) < scope.now;

							if (scope.disableWorkflow) {
								scope.job.workflow = getDefaultWorkflow(
									scope.job.workflowNames
								);
							}
						} else {
							if (scope.job.hasNoDate) {
								setFinishDate(jobStartDate);
							}
							scope.disableWorkflow = new Date(jobStartDate) < scope.now;
							if (scope.disableWorkflow) {
								scope.job.workflow = scope.job.oldWorkflow;
								scope.job.workflow.id = -1;
							}
						}
					}
				}

				function findAllMatchingClientNames(search) {
					clientsDataService
						.searchClient(search)
						.subscribe(
							data => findClientSuccessCallback(data),
							err => messageService.showDefaultErrorMessage(err)
						);
				}

				function findClientSuccessCallback(client) {
					if (client) {
						scope.idsNames = [];
						client.forEach(item => scope.idsNames.push(item));
					}
				}

				scope.createNewClient = (clientIndex, event) => {
					scope.newClient = {};
					utilsService.showNextModal(
						'#newJob',
						'#createNewJobClientModal',
						event
					);
					scope.clientIndex = clientIndex;
				};

				scope.closeAddClient = event => {
					utilsService.showNextModal(
						'#createNewJobClientModal',
						'#newJob',
						event
					);
				};

				scope.saveClient = event => {
					scope.isCreateClientModalSpinnningWheelActive = true;
					const lowercasedEmail = scope.newClient.email.toLowerCase();
					scope.newClient.email = lowercasedEmail;

					const client2SaveIndex = scope.clientIndex;
					if (!scope.companyNameChecked) {
						delete scope.newClient.companyName;
					}

					if (!validationService.isEmailValid(scope.newClient.email)) {
						scope.isCreateClientModalSpinnningWheelActive = false;
						return messageService.showToaster('e_3', 'companyUsers');
					}

					const clientFirstName = scope.newClient.firstName || '';

					if (!clientFirstName && !clientFirstName.trim()) {
						return messageService.showToaster('e_4', 'clients');
					}

					if (scope.newClient) {
						scope.newClient.notes = $rootScope.addMaiStyling(
							scope.newClient.notes
						);
					}

					clientsDataService
						.addNewClient(scope.newClient)
						.finally(
							() => (scope.isCreateClientModalSpinnningWheelActive = false)
						)
						.subscribe(
							data => successAddNewClient(data, client2SaveIndex, event),
							() => messageService.showToaster('e_6', 'clients')
						);
				};

				function successAddNewClient(data, client2SaveIndex, event) {
					scope.isCreateClientModalSpinnningWheelActive = false;
					if (data.errorMessage) {
						toastr.error(data.errorMessage, 'Error');
						return false;
					}

					delete scope.client;

					const clientSearchObj = clientService.fillClientSearchText(data);

					switch (client2SaveIndex) {
						case 0:
							const primaryClientSearchText = angular.copy(clientSearchObj);
							scope.job.primaryContact = primaryClientSearchText;
							break;
						case 1:
							const secondaryClientSearchText = angular.copy(clientSearchObj);
							scope.job.secondaryContact = secondaryClientSearchText;
							break;
						default:
							console.error('Unexpected client index');
					}

					messageService.showToaster('s_2', 'clients');
					utilsService.showNextModal(
						'#createNewJobClientModal',
						'#newJob',
						event
					);
				}

				scope.addOrUpdateJob = () => {
					delete $rootScope.error;

					const jobClients = [
						scope.job.primaryContact,
						scope.job.secondaryContact
					];
					const dataToSave = jobService.validateJob(scope.job, jobClients);

					if (dataToSave === false) {
						return false;
					}
					scope.button_disable = true;
					editJobRequest(dataToSave);
				};

				function editJobRequest(job) {
					newJobsDataService
						.editJob(job)
						.finally(() => {
							scope.button_disable = false;
						})
						.subscribe(
							data => {
								updateIntercom(job);
								editJobSuccessCallback(data, job.id);
							},
							err => editJobErrorCallback(err)
						);
				}

				function updateIntercom(job) {
					const metadata = {
						job_name: job.name,
						job_scheduled: job.startDate
					};
					Intercom('trackEvent', 'created job', metadata);
				}

				function editJobSuccessCallback(data, jobId) {
					if (jobId === undefined) {
						messageService.showToaster('s_0', 'job');
						$('#newJob').modal('hide');
					} else {
						messageService.showToaster('s_1', 'job');
						$('#newJob').modal('hide');
						leadSourcesDataService.updateLeadSourcesEvent(true);
					}

					if (data.id && !jobId) {
						$timeout(() => {
							$location.path(`/jobs/view/${data.id}`);
						}, 300);
					} else if (scope.updateParent) {
						scope.updateParent({ resetPagination: false });
					} else {
						$timeout(() => {
							$route.reload();
						}, 300);
					}
				}

				function editJobErrorCallback({ data, status }) {
					const errorMessage = data ? data.errorMessage : null;

					let errorCode, errorPlace;

					if (errorMessage && status >= 400 && status < 500) {
						if (
							status === 422 &&
							errorMessage.includes(
								'Job contact can not be changed because invoices have Xero payment'
							)
						) {
							errorCode = 'e_16';
							errorPlace = 'xero';
						} else if (
							errorMessage.includes(
								'Xero access token expired, reconnect Xero please'
							) ||
							errorMessage.includes(
								'Bummer! Xero access token not authorized or revoked, reconnect Xero please'
							) ||
							errorMessage.includes(
								'Bummer! Xero access token revoked, reconnect Xero please'
							)
						) {
							errorCode = 'e_14';
							errorPlace = 'xero';
						} else if (
							errorMessage.includes(
								"You don't have an active Xero subscription"
							)
						) {
							errorCode = 'e_15';
							errorPlace = 'xero';
						}
					} else {
						errorCode = 'e_0';
						errorPlace = 'general';
					}
					messageService.showToaster(errorCode, errorPlace);
				}

				scope.remove = function() {
					delete scope.job.secondaryContact;
					scope.showSecondClient = false;
				};

				scope.clearJobInfo = () => {
					delete scope.disableWorkflow;
				};

				scope.add = () => {
					const emptyClient = {
						name: ''
					};
					scope.job.secondaryContact = emptyClient;
					scope.showSecondClient = true;
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/updateJobModal.js